import React from 'react';
import './PublicDisclosureSection.css';

const generalInformation = [
  { sr: '1', info: 'Name of the School', detail: 'MAXFORT EDUCATION SCHOOL' },
  { sr: '2', info: 'Affiliation No.', detail: '1730846' },
  { sr: '3', info: 'School Code', detail: '11192' },
  {
    sr: '4',
    info: 'Complete Address with Pin Code',
    detail: 'Bedwa Lamps Street, near Vaghar Nagar, Partapur, Parliya Ki Dhani, Rajasthan 327024'
  },
  {
    sr: '5',
    info: 'Principal Name & Qualification',
    detail: 'ASUTOSH UPADHYAY (MSC. BIOTECHNOLOGY, S.L.E.T)'
  },
  { sr: '6', info: 'School Email ID', detail: 'maxforteducationschool@gmail.com' },
  { sr: '7', info: 'Contact Details', detail: ['9928620516', '9829961202', '9413015822'] },
  {
    sr: '8',
    info: 'CBSE Mandatory Data',
    detail: 'Click here',
    pdfFilename: 'APPEND IX Mandatory Public Disclosure.pdf'
  }
];

const documentsAndInformation = [
  {
    sr: '1',
    info: 'CBSE Affiliation Extension',
    detail: 'Click here',
    pdfFilename: 'cbse affiliation extantion up to 2025.pdf'
  },
  {
    sr: '2',
    info: 'Seva Skandh Registration',
    detail: 'Click here',
    pdfFilename: 'seva skandh registretion.pdf'
  },
  {
    sr: '3',
    info: 'Water Safety Certificate',
    detail: 'Click here',
    pdfFilename: 'Safe drinking water.pdf'
  },
  {
    sr: '4',
    info: 'Land Certificate',
    detail: 'Click here',
    pdfFilename: 'certificate of land.pdf'
  },
  {
    sr: '5',
    info: 'Fire Safety Certificate',
    detail: 'Click here',
    pdfFilename: 'Fire safety.pdf'
  },
  {
    sr: '6',
    info: 'Fees',
    detail: 'Click here',
    pdfFilename: 'fees.pdf'
  },
  {
    sr: '7',
    info: 'Affidavit',
    detail: 'Click here',
    pdfFilename: 'Untitled Apr 20, 2024.pdf'
  },
  {
    sr: '8',
    info: 'Academic Calendar',
    detail: 'Click here',
    pdfFilename: 'Academic calender.pdf'
  },
  {
    sr: '9',
    info: 'Parent Teacher Association Member (PTA)',
    detail: 'Click here',
    pdfFilename: 'PTA.pdf'
  },
  {
    sr: '10',
    info: 'Result of Board Examination',
    detail: 'Click here',
    pdfFilename: 'result board examination.pdf'
  },
  {
    sr: '11',
    info: 'School Management Committee',
    detail: 'Click here',
    pdfFilename: 'SMC School management Committee.pdf'
  },
  {
    sr: '12',
    info: 'CBSE Extension Letter',
    detail: 'Click here',
    pdfFilename: 'CBSE extension letter.pdf'
  },
  {
    sr: '13',
    info: 'Building Safety Certificate',
    detail: 'Click here',
    pdfFilename: 'building safety certtificate.pdf'
  },
  {
    sr: '14',
    info: 'Recognition Certificate and Registration under RTE',
    detail: 'Click here',
    pdfFilename: 'registration under RTE.pdf'
  }
];

const PublicDisclosureSection = () => {
  const handleDownload = (pdfFilename) => {
    const pdfUrl = `${process.env.PUBLIC_URL}/external/documents/${pdfFilename}`;
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const renderDetail = (row) => {
    if (row.pdfFilename) {
      return (
        <button
          type="button"
          className="clickhere"
          onClick={() => handleDownload(row.pdfFilename)}
        >
          {row.detail}
        </button>
      );
    }

    if (Array.isArray(row.detail)) {
      return row.detail.map((line) => (
        <span key={line} className="detail-line">
          {line}
        </span>
      ));
    }

    return row.detail;
  };

  const renderTable = (rows) => (
    <div className="table-scroll">
      <table className="table">
        <thead>
          <tr>
            <th className="col-sr">SR No.</th>
            <th className="col-info">Information</th>
            <th className="col-details">Details</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={`${row.sr}-${row.info}`}>
              <td data-label="SR No." className="srno">
                {row.sr}
              </td>
              <td data-label="Information">{row.info}</td>
              <td data-label="Details">{renderDetail(row)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="public-disclosure">
      <div className="public-disclosure-header">
        <h1>Mandatory Public Disclosure</h1>
      </div>

      <div className="table-section">
        <h3 className="section-title">A. GENERAL INFORMATION</h3>
        {renderTable(generalInformation)}
      </div>

      <div className="section">
        <h3 className="section-title">B. DOCUMENTS AND INFORMATION</h3>
        {renderTable(documentsAndInformation)}
      </div>
    </div>
  );
};

export default PublicDisclosureSection;
